import { render, staticRenderFns } from "./PostTag.vue?vue&type=template&id=2672b0c8&"
import script from "./PostTag.vue?vue&type=script&lang=js&"
export * from "./PostTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports